import * as React from 'react';
import * as ReactDom from 'react-dom';
//const Popup = require('react-popup');
import Popup from 'react-popup';

export class PopupWindow extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    public static showErrorMessage(title: any, message: any) {
        Popup.create({
            title: title,
            content: message,
            buttons: {
                right: ['ok']
            }
        }, true);
    }

    public static showErrorMessage1(title: any, message: any, Error: any) {
        Popup.create({
            title: title,
            content: message,
            className: 'Error',
            buttons: {
                right: ['ok']
            }
        }, true);
    }

    public static ClosePopup() {
        Popup.close();
    }
    /*  Added  method for to show Popupmessage RCNG - 5517 OMP shall allow the user to disable DIMI Term*/
    public static showDIMIMessage(title: any, message: any) {
        Popup.create({
            title: title,
            content: <table><tr><td><div>{message} </div></td> <td></td></tr>
                <tr><td><div className='alert alert-info'> The DIMI settings available here are only applied by reefers that have Intelligent PTI set to DIMI.</div></td></tr>
            </table>,
            buttons: {
                right: ['ok']
            }
        }, true);
    }
    public render() {
        return <Popup />
    }
}

